import { DetailsForWorkTemplate } from 'shared/components/work-forms/details/work-form-details.types';
import { ShiftDetailResponse } from 'shared/services/shift-service-types';
import { WorkTemplateDetail } from '../types';
import { ProjectDetail } from '../project/project-service.schema';

export function mapWorkTemplateToDetails(
  workTemplate: WorkTemplateDetail | undefined
): DetailsForWorkTemplate | undefined {
  if (!workTemplate) {
    return undefined;
  }

  return {
    descriptionShort: workTemplate.descriptionShort,
    descriptionLong: workTemplate.descriptionLong ?? '',
    descriptionLawRequirements: workTemplate.descriptionLawRequirements,
    contactName: workTemplate.contactName,
    contactPhoneNumber: workTemplate.contactPhoneNumber,
    location: workTemplate.location ?? null,
    jobTypeCertificates:
      workTemplate.jobCertificates?.map((cert) => ({
        certificate: { name: cert.name, id: cert.id },
      })) ?? [],
    certificates:
      workTemplate.requiredCertificates?.map((cert) => ({
        certificate: { name: cert.name, id: cert.id },
      })) ?? [],
    requirements:
      workTemplate.jobRequirements?.skills.map((req) => ({
        id: req.id,
        name: req.name,
      })) ?? [],
    flexPools: workTemplate.flexPools.map((pool) => ({ id: pool.id, name: pool.name })),
  };
}

export function mapProjectToDetails(project: ProjectDetail): DetailsForWorkTemplate {
  return {
    descriptionShort: project.descriptionShort,
    descriptionLong: project.descriptionLong,
    descriptionLawRequirements: project.descriptionLawRequirements,
    contactName: project.contactName,
    contactPhoneNumber: project.contactPhoneNumber,
    location: project.location,
    jobTypeCertificates: project.certificates.map((cert) => ({
      certificate: { name: cert, id: cert },
    })),
    certificates: project.certificates.map((cert) => ({
      certificate: { name: cert, id: cert },
    })),
    requirements:
      project.requirements?.skills.map((req) => ({
        id: req.id,
        name: req.name,
      })) ?? [],
    companyGrossHourlyRate: project.tempWorkProperties?.grossHourlyRateCents
      ? project.tempWorkProperties.grossHourlyRateCents / 100
      : undefined,
    flexPools: project.flexPools.map((flexPool) => ({ id: flexPool, name: flexPool })),
  };
}

export function mapShiftDetailToDetails(shift: ShiftDetailResponse): DetailsForWorkTemplate {
  return {
    descriptionShort: shift.descriptionShort,
    descriptionLong: shift.descriptionLong,
    descriptionLawRequirements: shift.descriptionLawRequirements,
    contactName: shift.contactName,
    contactPhoneNumber: shift.contactPhoneNumber,
    location: shift.location ?? null,
    jobTypeCertificates: shift.jobTypeCertificates ?? [],
    certificates: shift.certificates.map((cert) => ({
      certificate: { name: cert, id: cert },
    })),
    requirements: shift.requirements ?? [],
    companyGrossHourlyRate: shift.companyGrossHourlyRate,
    flexPools: shift.flexPools.map((pool) => ({ id: pool.id, name: pool.name })),
  };
}
